import { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const AffiliateInviteRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const trackReferral = async () => {
      try {
        const fromSlug = searchParams.get('from');
        const params = fromSlug ? `?from_slug=${encodeURIComponent(fromSlug)}` : '';
        const res = await axios.get(`${API}/affiliates/ref/${code}${params}`);
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `ref_affiliate=${res.data.affiliate_id}; expires=${expires}; path=/`;
        document.cookie = `ref_slug=${res.data.slug}; expires=${expires}; path=/`;
        if (res.data.master_id) {
          document.cookie = `ref_master=${res.data.master_id}; expires=${expires}; path=/`;
        }
      } catch {
        // Invalid code — redirect silently
      }
      navigate('/', { replace: true });
    };
    trackReferral();
  }, [code, navigate, searchParams]);

  return (
    <div className="min-h-screen bg-[#0A2647] flex items-center justify-center">
      <div className="animate-spin w-8 h-8 border-4 border-[#C5A059] border-t-transparent rounded-full" />
    </div>
  );
};

export default AffiliateInviteRedirect;
